import ApiService from "./MainServices";
import StorageService from "./StorageService";

const serviceApi = process.env.REACT_APP_SERVICE_URL;

const storageService = new StorageService();
const apiService = new ApiService();

export const API = {
  addPatientAddress: serviceApi + "/v1/transcript/address",
};

const header = {
  "Content-Type": "application/json",
  auth_token: storageService.get("token"),
  phone_no: storageService.get("phone_no"),
};

class AddressService {
  constructor() {}
  getPatientAddress(id: number, onResponse: any, onError: any) {
    let url = serviceApi + `/v1/transcript/address/${id}`;
    return apiService.get(
      url,
      header,
      (response: any) => {
        if (response) {
          onResponse(response);
        } else {
          onResponse([]);
        }
      },
      (error: any) => {
        onResponse([]);
        onError(error);
      },
    );
  }

  addPatientAddress(address: any, onResponse: any, onError: any) {
    let url = API.addPatientAddress;
    return apiService.post(
      url,
      header,
      address,
      (response: any) => {
        if (response) {
          onResponse(response);
        } else {
          onResponse([]);
        }
      },
      (error: any) => {
        onResponse([]);
        onError(error);
      },
    );
  }

  updatePatientAddress(
    addressId: number,
    patientId: number,
    address: any,
    onResponse: any,
    onError: any,
  ) {
    let url =
      serviceApi + `/v1/transcript/address/${addressId}?patientId=${patientId}`;
    return apiService.put(
      url,
      header,
      address,
      (response: any) => {
        if (response) {
          onResponse(response);
        } else {
          onResponse([]);
        }
      },
      (error: any) => {
        onError(error);
      },
    );
  }
}

export default AddressService;
